module.exports = __webpack_public_path__ + "img/unitech.855d15b8.png";